<template>
  <div class="Level">
    <div class="gameContent">
      <div :class="[ { active: isPreCountdownVisible }, 'levelHeading']">
        <LottieWrapper :options="getOptions.getReady" :size="size.getReady" ref="Lottie_GetReady" :completeHandler="null" />
        <LottieWrapper :options="getOptions[`level${ level }`]" :size="size[`level${ level }`]" ref="Lottie_LevelHeader" :completeHandler="null" />
        <YellowDotDemo ref="YellowDotDemo" :onDemoComplete="showTImer" :showGetReady="showGetReady" />
        <div class="countdownWrapper">
          <h4 v-if="!isChinese" ref="copy">{{ locale.BEGINS_IN }}</h4>
          <Countdown :totalSeconds="seconds" :onCountdownComplete="proceed" :onTrasitionReached="beginGame" :transitionSeconds="transitionSeconds" ref="Countdown" />
          <h4 v-if="isChinese" class="begins-copy-ch" ref="copy">{{ locale.BEGINS_IN }}</h4>
        </div>
      </div>
    </div>
    <Game ref="Game" :onComplete="onGameComplete" />
    <h5><SplittingText :outDirection="2" :text="instructionCopy" ref="SplittingText" /></h5>
    <div class="videoWrapper">
      <video src="@/assets/videos/game_bg.mp4" autoplay ref="bgVideo"></video>
    </div>
  </div>
</template>

<script>

import Countdown from '@/components/Countdown.vue'
import YellowDotDemo from '@/components/YellowDotDemo.vue'
import LottieWrapper from '@/components/LottieWrapper'
import SplittingText from '@/components/SplittingText'
import Game from '@/components/Game'

import { levelFlickerAudio, getReadyFlickerAudio } from '@/audio'

import { CONFIG } from '@/config'
import { SVGS } from '@/assets/svgs/locale_map'

import { TimelineLite, Expo, TweenLite } from 'gsap'

export default {
  name: 'Level',
  props: {
  },
  components: {
    Countdown,
    YellowDotDemo,
    LottieWrapper,
    SplittingText,
    Game
  },
  data() {
    return {
      levelState: 0,
      includeDemo: this.$store.state.level < 2,
      seconds: CONFIG.videoData[this.$store.state.game].preCountdownLength,
      transitionSeconds: CONFIG.videoData[this.$store.state.game].preCountdownTarget,
      isPreCountdownVisible: true,
      size: {
        level1: {
          width: 540,
          height: 100,
        },
        level2: {
          width: 540,
          height: 100,
        },
        level3: {
          width: 540,
          height: 100,
        },
        getReady: {
          width: 540,
          height: 50,
        }
      }
    }
  },
  mounted() {
    this.$store.commit( 'setHeaderVisibility', { isHeaderVisible: true } )

    this.initIdleStates()
    this.createAnimationTimeline()

    this.animateHeadingsIn.play()

    this.$refs.bgVideo.pause()
  },
  beforeRouteLeave( to, from, next ) {
    this.$store.commit( 'setTransitionVisibility', { isTransitionVisible: true } )
    clearTimeout( this.gameplayTimeout )

    setTimeout( () => {
        next()
    }, 150 )
  },
  computed: {
    level() { return this.$store.state.level },
    game() { return this.$store.state.game },
    locale() { return this.$store.state.lang },
    shouldShowDemo() { return this.includeDemo },
    isChinese() { return this.locale.LOCALE == "tc" || this.locale.LOCALE == "sc" },
    getOptions() {
      const { Level1Title, Level2Title, Level3Title, GetReady } = SVGS[ this.locale.LOCALE ]

      return {
        level1: {
          animationData: Level1Title.default,
          autoplay: false,
          loop: false
        },
        level2: {
          animationData: Level2Title.default,
          autoplay: false,
          loop: false
        },
        level3: {
          animationData: Level3Title.default,
          autoplay: false,
          loop: false
        },
        getReady: {
          animationData: GetReady.default,
          autoplay: false,
          loop: false
        }
      }
    },
    isMobile() { return this.$store.state.isMobile },
    instructionCopy() {
      return this.isMobile ? this.locale.LEVEL_INSTRUCTION_MOBILE : this.locale.LEVEL_INSTRUCTION
    },
  },
  methods: {
    initIdleStates() {
      TweenLite.to( this.$refs.copy, 0, { opacity: 0, y: '20%' } )
    },
    createAnimationTimeline() {
      const { Lottie_LevelHeader, Lottie_GetReady } = this.$refs

      this.animateHeadingsIn = new TimelineLite( { paused: true } )

      this.animateHeadingsIn
        .add( () => { Lottie_LevelHeader.play() }, 0.3 )
        .add( () => { levelFlickerAudio.play() }, 0.3 )
        .add( () => { this.level > 1 && Lottie_GetReady.play() }, 1 )
        .add( () => { getReadyFlickerAudio.play() }, this.level < 2 ? 4: 1 )
        .add( () => { this.showDemo() }, 0.3 )
    },
    showDemo() {
      ( this.level < 2 ) ? this.$refs.YellowDotDemo.animateElementsIn.play() : this.showTImer()
    },
    showGetReady() {
      this.$refs.Lottie_GetReady.play()
    },
    showTImer() {
      // console.log('show timer')
      TweenLite.to( this.$refs.copy, 0.6, { opacity: 1, y: '0%', ease: Expo.easeOut } )

      this.$store.commit( 'setCountdownVisibility', { isCountdownVisible: true } )
    },
    onGameComplete() {
      this.$router.push( { name: 'levelResult', query: { lang: this.locale.LOCALE } } )
    },
    proceed() {
      if ( this.isPreCountdownVisible ) {

        this.isPreCountdownVisible = false
        this.$refs.Countdown.stopCountdownAudio()
        this.seconds = CONFIG.videoData[this.game].length

      } else {

        this.$refs.Countdown.animateCountdownOut.play()

      }
    },
    beginGame() {
      if ( this.isPreCountdownVisible ) {

        this.$refs.Lottie_LevelHeader.reverse()
        this.$refs.Lottie_GetReady.reverse()

        let gameplayTimeout = setTimeout( () => {

          this.$refs.Game.startGamePlay()
          this.$refs.SplittingText.animateTextIn()

        }, 200 )

        TweenLite.to( this.$refs.copy, 0.6, { opacity: 0, y: '-20%' } )

      }
    },
  },
}
</script>

<style scoped lang="scss">

  @import '@/styles/core.scss';

  .Level {

    height: 100%;
    width: 100%;

    min-height: $page-min-height;
    position: relative;

    @include breakpoint( mobile-all ) {

      min-height: 100%;

    }

    .gameContent {

      position: absolute;
      top: 0;
      left: 0;

      width: 100%;
      height: 100%;

      min-height: $page-min-height;

      @include breakpoint( mobile-all ) {

        min-height: 100%;

      }

      display: flex;
      justify-content: center;
      flex-direction: column;

      .levelHeading {

        position: relative;
        z-index: 2;

        min-height: rem( 500 );

        @include breakpoint( mobile-all ) {

          min-height: rem( 500 );

        }

        @include breakpoint-width( 375px, 667px ) {

          margin-top: rem( 20 );
          min-height: rem( 450 );

        }

        .LottieWrapper:first-of-type {

          margin-bottom: rem( -60 );
          max-width: rem( 400 );
          max-height: rem( 40 );

          width: 100%;
          margin: 0 auto;

        }

        .LottieWrapper:nth-of-type(2) {

          max-width: rem( 400 );
          max-height: rem( 100 );

          width: 100%;
          margin: 0 auto;

        }

        .LottieWrapper {
          visibility: hidden;
        }

        &.active {

          .LottieWrapper {
            visibility: visible;
          }

        }

      }

      .countdownWrapper {

        height: 100%;
        width: 100%;

        h4 {

          @include uppercaseText();

         &.begins-copy-ch { margin-top: rem( 10 ) }

        }

        .Countdown {

          z-index: 2;

        }

      }

    }

    .videoWrapper {

      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;

      width: 100%;
      height: 100%;

      min-height: $page-min-height;

      @include breakpoint( mobile-all ) {

        min-height: 100%;

      }

    }

    video {

      // width: 100%;
      // height: 100%;
      //
      // object-fit: cover;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      min-width: 100%;
      min-height: 100%;
      width: auto;
      height: auto;

    }

    h5 {
      position: absolute;
      left: 0;
      right: 0;
      bottom: rem( 60 );
      width: 100%;


      @include lowecaseText();

      max-width: 70%;
      margin: 0 auto;

      @include breakpoint( mobile-all ) {

        bottom: 10%;

      }

    }

  }

</style>
